import { Address } from '../../types';

export type ContactsProps = {
  classes?: Record<string, string>;
  address: Address;
  withDivider?: boolean;
};

export const Contacts = (props: ContactsProps) => {
  const { classes, address, withDivider } = props;

  return (
    <div className={classes?.contacts} data-testid="gafe-contacts">
      <div className={classes?.contact}>
        <div className={classes?.label}>Phone:&nbsp;</div>
        <div data-testid="gafe-contacts-phone">{address.contact.phoneNumber ?? '-'}</div>
      </div>
      {withDivider && (
        <div className={classes?.divider} data-testid="gafe-contacts-divider">
          |
        </div>
      )}
      <div className={classes?.contact}>
        <div className={classes?.label}>Email:&nbsp;</div>
        <div className={classes?.email} data-testid="gafe-contacts-email">
          {address.contact.email ?? '-'}
        </div>
      </div>
    </div>
  );
};
